export interface SidebarItem {
  key: string;
  label: string;
  icon: string;
  route?: string;
  module?: string;        // Parent module (must match API feature_key)
  children?: SidebarItem[];
  auth?: 'public' | 'private';
}

export const SIDEBAR_CONFIG: SidebarItem[] = [

  /* ===================== DASHBOARD ===================== */

  {
    key: 'dashboard',
    label: 'Analytics',
    icon: 'fas fa-chart-line',
    route: '/main/home',
    module: 'dashboard',
    children: [

    ]
  },

  /* ===================== LEADS ===================== */

  {
    key: 'lead',
    label: 'Leads',
    icon: 'fas fa-envelope-open-text',
    route: '/main/leads-v2',
    module: 'lead',
    children: []
  },

  /* ===================== PATIENTS ===================== */

  {
    key: 'patient',
    label: 'Patients',
    icon: 'fas fa-user-friends',
    route: '/main/patients',
    module: 'patients',
    children: []
  },

  /* ===================== CAMPAIGN ===================== */

  // {
  //   key: 'campaign',
  //   label: 'Campaign',
  //   icon: 'fas fa-bullhorn',
  //   route: '/main/manage-campaign',
  //   module: 'campaign',
  //   children: []
  // },

  {
    key: 'sales-mail-hub',
    label: 'Mail Hub',
    icon: 'fas fa-inbox',
    route: '/main/sales-mail-hub',
    module: 'mail-hub'
  },
  {
    key: 'broadcast-campaign',
    label: 'Campaign',
    icon: 'fas fa-broadcast-tower',
    route: '/main/broadcast-campaign',
    module: 'broadcast-campaign'
  },

  /* ===================== APPOINTMENT ===================== */

  {
    key: 'appointment',
    label: 'Appointments',
    icon: 'fas fa-calendar-alt',
    route: '/main/appointments',
    module: 'appointment',
    children: []
  },

  /* ===================== OPD ===================== */

  {
    key: 'opd',
    label: 'OPD',
    icon: 'fas fa-calendar-check',
    route: '/main/out-patient',
    module: 'opd',
    children: []
  },

  /* ===================== IPD ===================== */

  {
    key: 'ipd',
    label: 'IPD',
    icon: 'fas fa-hospital-user',
    route: '/main/in-patient',
    module: 'ipd',
    children: []
  },

  /* ===================== PHARMACY ===================== */

  {
    key: 'pharmacy',
    label: 'Pharmacy',
    icon: 'fas fa-prescription-bottle',
    route: '/main/pharmacy',
    module: 'pharmacy',
    children: []
  },

  /* ===================== OPTICALS ===================== */

  {
    key: 'optical',
    label: 'Opticals',
    icon: 'fas fa-glasses',
    route: '/main/optical',
    module: 'optical',
    children: []
  },

  /* ===================== REPORTS ===================== */

  {
    key: 'report',
    label: 'Reports',
    icon: 'fas fa-file',
    route: '/main/reports',
    module: 'report',
    auth: 'private',
    children: [
      {
        key: 'opd-billing',
        label: 'OPD Billings',
        icon: 'fas fa-inventory',
        route: '/main/opd-statement',
        module: 'report'
      },
      {
        key: 'ipd-statement',
        label: 'IPD Billings',
        icon: 'fas fa-calendar',
        route: '/main/ipd-statement',
        module: 'report'
      },
      {
        key: 'cancel-refund',
        label: 'Cancel & Refund Report',
        icon: 'fas fa-times-circle',
        route: '/main/management-reports/cancel-refund-report',
        module: 'report'
      },
      {
        key: 'patient-summary',
        label: 'Patient Summary Report',
        icon: 'fas fa-user',
        route: '/main/management-reports/patient-summary-report',
        module: 'report'
      },
      {
        key: 'allergy',
        label: 'Allergy Report',
        icon: 'fas fa-allergies',
        route: '/main/management-reports/allergy-report',
        module: 'report'
      },
      {
        key: 'problem-diagnosis',
        label: 'Problem Diagnosis Report',
        icon: 'fas fa-notes-medical',
        route: '/main/management-reports/problem-diagnosis-report',
        module: 'report'
      },
      {
        key: 'visit-history',
        label: 'Visit History Report',
        icon: 'fas fa-history',
        route: '/main/management-reports/visit-history-report',
        module: 'report'
      },
      {
        key: 'medication-history',
        label: 'Medication History Report',
        icon: 'fas fa-pills',
        route: '/main/management-reports/medication-history-report',
        module: 'report'
      },
      {
        key: 'procedure-history',
        label: 'Procedure History Report',
        icon: 'fas fa-procedures',
        route: '/main/management-reports/procedure-history-report',
        module: 'report'
      },
      {
        key: 'referral',
        label: 'Referral Report',
        icon: 'fas fa-share-square',
        route: '/main/management-reports/referral-report',
        module: 'report'
      }
    ]
  },

  /* ===================== TICKETS ===================== */

  {
    key: 'ticket',
    label: 'Tickets',
    icon: 'fas fa-ticket-alt',
    route: '/main/manage-tickets',
    module: 'ticket',
    children: []
  },

  /* ===================== AI OCR ===================== */

  {
    key: 'ai-ocr',
    label: 'AI OCR',
    icon: 'fas fa-brain',
    route: '/main/ai-ocr',
    module: 'ai-ocr',
    children: [
      {
        key: 'ocr-extract',
        label: 'Document Extraction',
        icon: 'fas fa-file-medical-alt',
        route: '/main/ai-ocr',
        module: 'ai-ocr'
      },
      {
        key: 'document-chat',
        label: 'Chat with Document',
        icon: 'fas fa-comments',
        route: '/main/ai-ocr/document-chat',
        module: 'ai-ocr'
      }
    ]
  },

  /* ===================== SETTINGS ===================== */

  {
    key: 'setting',
    label: 'Settings',
    icon: 'fas fa-cog',
    route: '/main/settings',
    module: 'setting',
    children: [
      {
        key: 'pipeline-configuration',
        label: 'Pipeline Configuration',
        icon: 'fas fa-sitemap',
        route: '/main/configuration/pipeline-configuration',
        module: 'setting'
      },
      {
        key: 'ai-scoring-guidelines',
        label: 'AI Scoring Guidelines',
        icon: 'fas fa-robot',
        route: '/main/configuration/ai-scoring-guidelines',
        module: 'setting'
      },
      {
        key: 'dynamic-fields',
        label: 'Dynamic Fields',
        icon: 'fas fa-sliders-h',
        route: '/main/leads-v2/settings/dynamic-fields',
        module: 'setting'
      },
      {
        key: 'price-setting',
        label: 'Pricing Catalog',
        icon: 'fas fa-inventory',
        route: '/main/price-settings',
        module: 'setting'
      },
      {
        key: 'coupon-setting',
        label: 'Coupons',
        icon: 'fas fa-receipt',
        route: '/main/coupon-settings',
        module: 'setting'
      },
      {
        key: 'schedule-setting',
        label: 'Appointment Schedule',
        icon: 'fas fa-calendar',
        route: '/main/configuration-schedule',
        module: 'setting'
      },
      {
        key: 'user',
        label: 'Users',
        icon: 'fas fa-users',
        route: '/main/configuration-users',
        module: 'setting'
      },
      {
        key: 'procedure-packages',
        label: 'Procedure Packages',
        icon: 'fas fa-box',
        route: '/main/procedure-packages',
        module: 'setting'
      },
      {
        key: 'drug-inventory',
        label: 'Drug Inventory',
        icon: 'fas fa-pills',
        route: '/main/drug-inventory',
        module: 'setting'
      },
      {
        key: 'supply-inventory',
        label: 'Supply Inventory',
        icon: 'fas fa-boxes',
        route: '/main/supply-inventory',
        module: 'setting'
      },
      {
        key: 'equipment-inventory',
        label: 'Equipment Inventory',
        icon: 'fas fa-tools',
        route: '/main/equipment-inventory',
        module: 'setting'
      },
      {
        key: 'email-setting',
        label: 'Email',
        icon: 'fas fa-envelope',
        route: '/main/configuration-email',
        module: 'setting'
      },
      {
        key: 'addon-services',
        label: 'Addon Services',
        icon: 'fas fa-chart-line',
        route: '/main/pricing-dashboard',
        module: 'setting'
      },
      {
        key: 'contact-group',
        label: 'Contact Groups',
        icon: 'fas fa-users-cog',
        route: '/main/contact-groups',
        module: 'setting'
      },
      {
        key: 'whatsapp-template',
        label: 'WhatsApp Template',
        icon: 'fab fa-whatsapp',
        route: '/main/configuration-whatsapp-template',
        module: 'setting'
      },
      {
        key: 'email-template',
        label: 'Email Template',
        icon: 'fas fa-envelope-open',
        route: '/main/configuration-email-template',
        module: 'setting'
      },
      {
        key: 'client-setting',
        label: 'Client Settings',
        icon: 'fas fa-sliders-h',
        route: '/main/client-settings',
        module: 'setting'
      },
      {
        key: 'domain-authentication',
        label: 'Domain Authentication',
        icon: 'fas fa-globe',
        route: '/main/domain-authentication',
        module: 'setting'
      },
      {
        key: 'form-builder',
        label: 'Dynamic Form Builder',
        icon: 'fas fa-file-signature',
        route: '/main/settings/form-builder',
        module: 'setting'
      }
    ]
  }
];
